import React, { useState } from 'react';
import { useTheme } from '../../contexts/ThemeContext.tsx';
import { getSafeHttpsUrl } from '../../utils/safeUrl.ts';
import positiveSeal from './assets/asaas-servicos-financeiros-positivo.png';
import negativeSeal from './assets/asaas-servicos-financeiros-negativo.png';

// Optional CDN override: accept the personalized public URL, never the PDF's example.
export const getAsaasSealUrl = (value?: string): string | null => {
  const url = getSafeHttpsUrl(value);
  if (!url) return null;
  const parsed = new URL(url);
  if (parsed.hostname !== 'baas.asaas.com' || !parsed.pathname.startsWith('/selos/')) return null;
  if (!parsed.searchParams.get('id') || /^x+$/i.test(parsed.searchParams.get('id') || '')) return null;
  return url;
};

const AsaasAttribution = () => {
  const { isDark } = useTheme();
  const lightUrl = getAsaasSealUrl(process.env.REACT_APP_ASAAS_SEAL_LIGHT_URL);
  const darkUrl = getAsaasSealUrl(process.env.REACT_APP_ASAAS_SEAL_DARK_URL);
  const preferredUrl = isDark ? darkUrl || lightUrl : lightUrl;
  const localSeal = isDark ? negativeSeal : positiveSeal;
  const [failedUrls, setFailedUrls] = useState<string[]>([]);
  const sealUrl = preferredUrl && !failedUrls.includes(preferredUrl) ? preferredUrl : localSeal;

  return (
    <aside className="billing-attribution" aria-label="Serviços financeiros Asaas">
      {!failedUrls.includes(sealUrl) ? (
        <img src={sealUrl} alt="Serviços financeiros Asaas" width={752} height={275}
          className={isDark && sealUrl === lightUrl ? 'billing-seal billing-seal-positive' : 'billing-seal'}
          onError={() => setFailedUrls((current) => [...current, sealUrl])} />
      ) : (
        <p className="billing-attribution-name">Serviços financeiros<br /><strong>Asaas</strong></p>
      )}
      <div>
        <p>Pagamentos processados pelo Asaas.</p>
        <p className="billing-attribution-support">Suporte financeiro: <a href="mailto:contato@asaas.com.br">contato@asaas.com.br</a></p>
      </div>
    </aside>
  );
};

export default AsaasAttribution;
